<template>
  <div class="text-center">
    <v-dialog
      v-model="modalEnabled"
      max-width="540"
    >
      <v-card>
        <v-card-title class="">
          <v-spacer />
          {{ !isCertified ? 'Добавление обучения' : 'Удаление обучения' }}
          <v-spacer />
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row v-if="!isCertified">
              <v-col
                cols="12"
                :sm="12"
              >
                <span>
                  {{ `Добавить данного соискателя в обучение вакансии?` }}

                </span>
              </v-col>
            </v-row>
            <v-alert
              v-else
              prominent
              text
              dense
              class="py-1 my-1"
              type="error"
            >
              <span style="font-size: 0.9em; display: block">
                {{ ` Этот соискатель был добавлен в обучении ${appFormatDateTime(certificationDate)}.` }}
              </span>
              <span style="font-size: 0.9em; display: block">
                {{ `Если вы удалите его обучение,
он не сможет больше откликаться на эту вакансию пока снова не будет добавлен в список обученных` }}
              </span>
            </v-alert>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions v-if="isCertified">
          <v-btn
            text
            @click="cancel"
          >
            Передумал
          </v-btn>
          <v-spacer />
          <v-btn
            text
            color="error"
            @click="save"
          >
            Удалить обучение
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn
            text
            @click="cancel"
          >
            Передумал
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="!canSave"
            text
            rounded
            outlined
            color="success"
            @click="save"
          >
            Подтвердить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: 'CreateLaborerCertification',
  props: {
    modalEnabled: {
      type: Boolean,
      default: false
    },
    laborerCertification: {
      type: Object,
    },
    vacancyCertification: {
      type: Object,
    },
  },
  data () {
    return {
      reasonList: [],
      model: {
        vacancyCertification: null,
        description: null,
        value: null,
      }
    }
  },
  computed: {
    canSave () {
      return true
    },
    isCertified () {
      return this.laborerCertification && this.laborerCertification.id
    },
    certificationDate () {
      if (!this.isCertified) {
        return ''
      }
      return this.laborerCertification.createdAt
    },
  },
  async created () {
  },
  methods: {
    save () {
      this.$emit(
        'onCreateLaborerCertificationModalSuccess',
        { description: this.model.description }
      )
    },
    cancel () {
      this.$emit('onCreateLaborerCertificationModalCanceled')
    },
  }
}
</script>
